import { render, staticRenderFns } from "./StatusTags.vue?vue&type=template&id=52a72526&scoped=true&"
import script from "./StatusTags.vue?vue&type=script&lang=js&"
export * from "./StatusTags.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/status-tags.scss?vue&type=style&index=0&id=52a72526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a72526",
  null
  
)

export default component.exports